import * as React from 'react';

import styled from '@emotion/styled';
import { Box, Flex } from '@opendoor/bricks/core';
import { ThemedLite } from '@opendoor/bricks/theme/ODThemeLite';

import Header from 'src/components/flowPage/twoColumn/Header';

import Footer from '../flowPage/twoColumn/Footer';

export const ContentContainer = styled.div`
  margin: 0 auto;
  box-sizing: border-box;
  width: 100%;

  @media (max-width: 921px) {
    max-width: 480px;
    padding: 0 20px;
  }
  @media (min-width: 922px) {
    max-width: 1440px;
    padding: 0 64px;
  }
`;

export const PageLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <ThemedLite theme="novo">
      <Box display="flex" flexDirection="column" minHeight="100vh">
        {children}
      </Box>
    </ThemedLite>
  );
};

export const PageHeader: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Box backgroundColor="white0">
      <ContentContainer>
        <Header>{children}</Header>
      </ContentContainer>
    </Box>
  );
};

export const PageContent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Flex backgroundColor="neutrals20" flexGrow={1} flexDirection="column" alignItems="center">
      <Box
        marginTop={[6, null, 11]}
        width="100%"
        paddingX={['20px', null, null, '64px']}
        maxWidth={['480px', null, '1440px']}
      >
        {children}
      </Box>
      <Box data-testid="reception-footer" marginY={['48px', null, '64px']}>
        {/* this is hidden only when we're in the app */}
        <Footer />
      </Box>
    </Flex>
  );
};
